import { InteractiveCreativeFile } from '@lib/iab/iab-vast-model';

interface IInteractiveCreativeFile {
    type: string;
    apiFramework: string;
    _value: string;
}

const createInteractiveMediaFile = (
    $interactiveCreativeFile: IInteractiveCreativeFile
): InteractiveCreativeFile => {
    const interactiveCreativeFile = new InteractiveCreativeFile();
    interactiveCreativeFile.type = $interactiveCreativeFile.type;
    interactiveCreativeFile.apiFramework =
        $interactiveCreativeFile.apiFramework;
    interactiveCreativeFile.uri = $interactiveCreativeFile._value;
    return interactiveCreativeFile;
};

export default createInteractiveMediaFile;
